import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { persistor, pgStore } from '../pgStore';
import { PersistGate } from 'redux-persist/integration/react';
import { FluentProvider } from '@fluentui/react-components';
import { PeerGamingDarkTheme } from '../Theme/PeerGamingDarkTheme';
import Application from './Application';
import { GoogleOAuthProvider } from '@react-oauth/google';

const ApplicationInitializer = () => {
	useEffect(() => {
		const appHeight = () => {
			document.documentElement.style.setProperty(
				'--app-height',
				`${String(window.innerHeight)}px`
			);
		};
		window.addEventListener('resize', appHeight);
		appHeight();
	}, []);

	return (
		<GoogleOAuthProvider clientId='914497026687-2324fo4802r4r479tm3ten9jmdct3an1.apps.googleusercontent.com'>
			<React.StrictMode>
				<Provider store={pgStore}>
					<PersistGate
						loading={null}
						persistor={persistor}
					>
						<FluentProvider theme={PeerGamingDarkTheme}>
							<Application />
						</FluentProvider>
					</PersistGate>
				</Provider>
			</React.StrictMode>
		</GoogleOAuthProvider>
	);
};

export default ApplicationInitializer;
